import { render } from "./EditPaymentLink.vue?vue&type=template&id=2d0ac514"
import script from "./EditPaymentLink.vue?vue&type=script&lang=js"
export * from "./EditPaymentLink.vue?vue&type=script&lang=js"
script.render = render

export default script